import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Lightbox = ({ tile, onClose }) => {
  const name = tile ? tile.split("/").pop() : null;
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (name) setSrc(`/collage/full/${name}`);
  }, [name]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {tile && (
        <motion.div
          data-testid="lightbox-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
          className="fixed inset-0 z-[80] flex items-center justify-center p-6 md:p-14"
          style={{ background: "rgba(3,6,8,0.9)", backdropFilter: "blur(10px)" }}
          onClick={onClose}
        >
          <motion.img
            key={src}
            data-testid="lightbox-image"
            src={src}
            alt="Artwork from the collage"
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.98 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="max-h-[85vh] max-w-[92vw] object-contain"
            style={{ boxShadow: "0 0 80px rgba(3,6,8,0.9), 0 0 0 1px rgba(212,175,55,0.25)" }}
            onClick={(e) => e.stopPropagation()}
            onError={() => {
              if (src !== tile) setSrc(tile); // fall back to the tile-sized image
            }}
          />
          <button
            data-testid="lightbox-close"
            aria-label="Close"
            onClick={onClose}
            className="absolute right-6 top-6 text-[#8b9a9a] transition-colors duration-500 hover:text-[#d4af37] md:right-10 md:top-8"
          >
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" aria-hidden="true">
              <path d="M4 4 L22 22 M22 4 L4 22" stroke="currentColor" strokeWidth="1" />
            </svg>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Lightbox;
